import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

const TitleRow = ({ nameM, nameF, dateTimeM, dateTimeF, locationM, locationF }) => {
    const { t } = useTranslation();

    return (
        <div style={{
            width: '100%',
            padding: '4px 0'
        }}>
            <div style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: '100%',
                marginBottom: '4px'
            }}>
                <div style={{ flex: 0.2, textAlign: 'left', fontWeight: 'bold', fontSize: '0.8rem' }}>
                    නමඃ ශ්‍රී ඝණාය!
                </div>
                <div style={{ flex: 0.6, textAlign: 'center', fontWeight: 'bold', fontSize: '1rem' }}>
                    {t('PORONDAM_REPORT')}
                </div>
                <div style={{ flex: 0.2, textAlign: 'left', fontWeight: 'bold', fontSize: '0.8rem' }}>
                </div>
            </div>
            
            <div style={{
                display: 'flex',
                alignItems: 'center',
                width: '100%',
                marginTop: '4px'
            }}>
                <div style={{ flex: '0 0 10%', fontWeight: 'bold', fontSize: '0.8rem', textAlign: 'left', paddingRight: '8px' }}>
                    නම:
                </div>
                <div style={{ flex: '0 0 45%' }}>
                    <input
                        type="text"
                        style={{ width: '100%', fontSize: '0.8rem', padding: '2px 4px' }}
                        defaultValue={nameM}
                        name="namaand"
                    />
                </div>
                <div style={{ flex: '0 0 45%' }}>
                    <input
                        type="text"
                        style={{ width: '100%', fontSize: '0.8rem', padding: '2px 4px' }}
                        defaultValue={nameF}
                        name="namaand"
                    />
                </div>
            </div>
            <div style={{
                display: 'flex',
                alignItems: 'center',
                width: '100%',
                marginTop: '4px'
            }}>
                <div style={{ flex: '0 0 10%', fontWeight: 'bold', fontSize: '0.8rem', textAlign: 'left', paddingRight: '8px' }}>
                    වේලාව:
                </div>
                <div style={{ flex: '0 0 45%', fontSize: '0.6rem' }}>
                    <span>{dateTimeM}</span>
                </div>
                <div style={{ flex: '0 0 45%', fontSize: '0.6rem' }}>
                    <span>{dateTimeF}</span>
                </div>
            </div>
            <div style={{
                display: 'flex',
                alignItems: 'center',
                width: '100%',
                marginTop: '4px'
            }}>
                <div style={{ flex: '0 0 10%', fontWeight: 'bold', fontSize: '0.8rem', textAlign: 'left', paddingRight: '8px' }}>
                    ස්ථානය:
                </div>
                <div style={{ flex: '0 0 45%', fontSize: '0.6rem' }}>
                    <span>{locationM}</span>
                </div>
                <div style={{ flex: '0 0 45%', fontSize: '0.6rem' }}>
                    <span>{locationF}</span>
                </div>
            </div>
        </div>
    );
};

TitleRow.propTypes = {
    nameM: PropTypes.string.isRequired,
    nameF: PropTypes.string.isRequired,
    dateTimeM: PropTypes.string.isRequired,
    dateTimeF: PropTypes.string.isRequired,
    locationM: PropTypes.string.isRequired,
    locationF: PropTypes.string.isRequired,
};

TitleRow.propTypes = {
    name: PropTypes.string.isRequired,
    location: PropTypes.string.isRequired,
};

export default TitleRow;